export class DisabledDto {
        product: string;
        campaign: string;
        customers: string[];
}
